import Api from "../../axios";

export default async function apiTodayOnLeave() {
  return await Api.get(`/employee_on_leave`);
}
